(function () {
  $("body").on('click', ".collapsible-tab-content summary", function () {
    let parent = $(this).parents('.collapsible-tab-content');
    let content = parent.find('.rte');

    if (content.is(':visible')) {
      parent.removeClass('opened');
      content.slideUp();
    } else {
      parent.addClass('opened');
      content.slideDown();
    }
  });
})()

$(document).ready(function() {

  // Handle the decrease button click
  $(".js-qty__adjust--minus").click(function() {
    var quantityInput1 = $(this).closest("#CollectionAddToCartForm").find("#Quantity");
    var currentValue = parseInt(quantityInput1.val());
    if (currentValue > 1) {
      quantityInput1.val(currentValue - 1);
    }
  });

  // Handle the increase button click
  $(".js-qty__adjust--plus").click(function() {
    var quantityInput = $(this).closest("#CollectionAddToCartForm").find("#Quantity");
    var currentValue = parseInt(quantityInput.val());
    quantityInput.val(currentValue + 1);
  });

});

$(document).ready(function() {
  var a;
  a = setInterval(fun, 100);
  function fun() {

    if ($(".product-recommendations .quick-add-button").length) {

      // Handle the decrease button click
      $(".js-qty__adjust--minus").click(function() {
        var quantityInput1 = $(this).closest("#CollectionAddToCartForm").find("#Quantity");
        var currentValue = parseInt(quantityInput1.val());
        if (currentValue > 1) {
          quantityInput1.val(currentValue - 1);
        }
      });

      // Handle the increase button click
      $(".js-qty__adjust--plus").click(function() {
        var quantityInput = $(this).closest("#CollectionAddToCartForm").find("#Quantity");
        var currentValue = parseInt(quantityInput.val());
        quantityInput.val(currentValue + 1);
      });


      $("#CollectionAddToCartForm .quick-add-button").on("click", function() {

        var variantId = $(this).attr("v_id");
        var quantity = $(this).closest("#CollectionAddToCartForm").find("#Quantity").val();

        // Use Shopify's AJAX API to add the product to the cart
        jQuery.post('/cart/add.js', {
          quantity: quantity,
          id: variantId
        }).done(function(response) {
          var neURL =  "/"+"cart";
          window.location.href = neURL;
        });
      });

      clearInterval(a);
    }
  }
});